module.exports = __webpack_public_path__ + "static/media/foundation-header@2x.389fe653.jpg";